import { lazy } from "react";

import Loadable from "../styles/ui-component/Loadable";
import MinimalLayout from "../layout/MinimalLayout";
import RestrictedRoute from "./RestrictedRoute";
import ChangePassword from "../pages/Authentication/authentication/ChangePassword";

const AuthLogin = Loadable(lazy(() => import("../pages/Authentication/authentication/Login")));

const AuthenticationRoutes = {
  path: "/",
  element: (
    <RestrictedRoute authRequirement={false}>
      <MinimalLayout />
    </RestrictedRoute>
  ),
  children: [
    {
      path: "/login",
      element: <AuthLogin />,
    },
    {
      path:"/changePassword",
      element: <ChangePassword/>
    }
  ],
};

export default AuthenticationRoutes;
